import { environment } from '../../environments/environment';
/** The app config class is used to store application config variables (like the api endpoint url)
* in a single place that's easily injected into any component.
* It is applied in global.
*/
export class AppConfigs {
    /** Default date short format. */
    public readonly dateFormat = 'yyyy-MM-dd';
    /** Default datetime long format. */
    public readonly dateTimeFormat = 'yyyy-MM-dd h:mm:ss a';
    /** Default language for application. Work for multiple language support. */
    public readonly defaultLanguage = 'en-us';
    /** Defined the application applied theme. */
    public readonly defaultTheme = 'pink';
    /** If value = true, send angular application logging information or exceptions back to server side. corporate with web api call.
     * Note: enable this setting could cause performance issue. Convern.
    */
    public readonly sendClientLogToServer = false;

    public readonly enableDynamicTheme = false;
    /** It is Identity server 4 root url. work for security.oidc.service. */
    public readonly IAMUrl = environment.IAMUrl;
    /** Value of seconds. time before access token expire. Now, it is 180 seconds / 3 minutes before access token expire. */
    public readonly accessTokenExpiringNotificationTime = 180;
    /**
     *  Work for Oidc client setting. When value = true, no need to show popup warning message dialog to user for manual continue session.
     *  if value = false, system will display popup warning dialog to use for manually continue session.
     *  Corporate with dialog.component.ts and security.oidc.service.
     */
    public readonly isAccessTokenAutoRenew = true;
  }

  /**
   * Global const contains all custom settings.
   */
  export const APP_CONFIGS = new AppConfigs();
